export const formatCompactCurrency = (value) => {
    const numericValue = Number(value || 0);
  
    if (numericValue >= 1000000 && numericValue < 999999999) {
      const compact = Math.round((numericValue / 1000000) * 10) / 10;
      return `€${Number.isInteger(compact) ? compact : compact.toFixed(1)}m`;
    }
  
    if (numericValue >= 1000 && numericValue < 1000000) {
      const compact = Math.round((numericValue / 1000) * 10) / 10;
      return `€${Number.isInteger(compact) ? compact : compact.toFixed(1)}k`;
    }
  
    if (numericValue >= 999999999) {
      return "€5m+";
    }
  
    return `€${numericValue.toLocaleString("en-IE", {
      maximumFractionDigits: 0,
    })}`;
  };
  
  export const formatPrice = (value) => {
    const numericValue = Number(value || 0);
  
    return `€${numericValue.toLocaleString("en-IE", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })}`;
  };
  
  export const setActiveTabs = (tabs, activeType) => {
    tabs.forEach((tab) => {
      const isActive = tab.dataset.type === activeType;
  
      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
    });
  };
  
  export const renderOptionButtons = (container, options, activeIndex) => {
    container.innerHTML = "";
  
    options.forEach((option, index) => {
      const button = document.createElement("button");
  
      button.type = "button";
      button.className = "option-button";
      button.dataset.js = "investment-option";
      button.dataset.optionIndex = String(index);
      button.textContent = option.displayLabel;
  
      if (index === activeIndex) {
        button.classList.add("is-active");
      }
  
      container.appendChild(button);
    });
  };
  
  export const showSliderMode = ({
    slider,
    sliderWrap,
    optionsWrap,
    selection,
  }) => {
    sliderWrap.classList.remove("is-hidden");
    optionsWrap.classList.add("is-hidden");
    optionsWrap.innerHTML = "";
  
    slider.min = "0";
    slider.max = String(selection.sliderMax);
    slider.step = "1";
    slider.value = String(selection.index);
    slider.disabled = selection.sliderMax === 0;
  };
  
  export const showOptionsMode = ({
    sliderWrap,
    optionsWrap,
    selection,
  }) => {
    sliderWrap.classList.add("is-hidden");
    optionsWrap.classList.remove("is-hidden");
  
    renderOptionButtons(optionsWrap, selection.options, selection.index);
  };
  
  export const updateCalculatorUi = ({
    calculator,
    tabs,
    typeKey,
    primaryLabelElement,
    qualifierElement,
    revenueValueElement,
    priceValueElement,
    selection,
    formatPriceFn,
  }) => {
    calculator.dataset.type = typeKey;
  
    setActiveTabs(tabs, typeKey);
  
    primaryLabelElement.textContent = selection.primaryLabel;
    qualifierElement.textContent = selection.qualifier;
    qualifierElement.classList.toggle("is-hidden", selection.qualifier === "");
    revenueValueElement.textContent = selection.displayValue;
    priceValueElement.textContent = formatPriceFn(selection.price);
  };
  
  // Used only for resize-driven layout work.
  // This avoids recalculating height on every single resize event tick.
  export const debounce = (fn, delay = 150) => {
    let timeoutId;
  
    return (...args) => {
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => fn(...args), delay);
    };
  };
  
  // This keeps the calculator card from visually jumping
  // when switching between tabs with different content heights.
  export const syncStableCardHeight = ({
    calculator,
    activeType,
    selectedIndexes,
    config,
    render,
  }) => {
    const currentType = activeType.value;
    const currentIndex = selectedIndexes[currentType];
    let maxHeight = 0;
  
    calculator.style.minHeight = "";
  
    Object.keys(config).forEach((typeKey) => {
      render(typeKey, selectedIndexes[typeKey]);
      maxHeight = Math.max(maxHeight, calculator.offsetHeight);
    });
  
    render(currentType, currentIndex);
  
    if (maxHeight > 0) {
      calculator.style.minHeight = `${maxHeight}px`;
    }
  };